import {AppliedDiscountDiscountTypeWithLiterals} from '@wix/auto_sdk_ecom_current-cart';
import {V2Coupon as Coupon} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {ModelContext} from '../../../types/app.types';
import {SPECS} from '../../specs';

export class CouponModel {
  public id: string;
  public code: string;
  /**
   * @deprecated
   */
  public discountType?: AppliedDiscountDiscountTypeWithLiterals;

  constructor(params: CouponModel) {
    this.id = params.id;
    this.code = params.code;
    this.discountType = params.discountType;
  }

  public static fromCartV1(
    coupon: Coupon,
    discountType: AppliedDiscountDiscountTypeWithLiterals,
    modelContext: ModelContext
  ) {
    return new CouponModel({
      id: coupon?._id,
      code: coupon?.code,
      discountType: modelContext.viewerContext.isExperimentEnabled(SPECS.RefactorCouponOnCart)
        ? undefined
        : discountType,
    });
  }

  public static fromCartV2(coupon: Coupon): CouponModel {
    return new CouponModel({
      id: coupon._id,
      code: coupon.code,
    });
  }
}
